import { Output, EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class Emitters {
    @Output() InnerEmiter: EventEmitter<any> = new EventEmitter();
    change(data) {
        this.InnerEmiter.emit(data);
    }

    getEmittedValue() {
        return this.InnerEmiter;
    }
}
